import * as firebase from 'firebase';

let config = {
    apiKey: "AIzaSyCz1UQHFGUwB0Q9rV6XeisX3cFJ7p6_Yr4",
    authDomain: "automatron-2480b.firebaseapp.com",
    databaseURL: "https://automatron-2480b.firebaseio.com",
    projectId: "automatron-2480b",
    storageBucket: "automatron-2480b.appspot.com",
    messagingSenderId: "849146338291"
};
var fire = firebase.initializeApp(config);
export default fire;


// WEBPACK FOOTER //
// ./src/firebase.js